<template>
  <div class="compay-intro">
    <main-intro />
    <contents1 />
    <contents2 />
    <contents3 />
  </div>
</template>

<script>
import mainIntro from '@/components/contents/intro/MainIntro'
import contents1 from '@/components/contents/intro/Contents1'
import contents2 from '@/components/contents/intro/Contents2'
import contents3 from '@/components/contents/intro/Contents3'

export default {
  components: {
    mainIntro,
    contents1,
    contents2,
    contents3
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/view/CompanyIntro.vue